import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import axiosClient from '../../../components/api/axiosClient';
import LoadContentSpinner from '../../../components/Utils/LoadContentSpinner';
import FormDatasEdit from './components/FormDatasEdit';

export default function EditEventRequest() {

    const imagePath = process.env.REACT_APP_IMAGE_PATH;
    const { id } = useParams();  // Récupérer l'ID de l'événement à partir de l'URL
    const [error, setError] = useState(null); // Nouvel état pour gérer les erreurs
    const [eventDetails, setEventDetails] = useState({});
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(true);

    const fetchEventValidatorDetails = async () => {
        setLoading(true);
        setError(null);   // Réinitialiser les erreurs
        // Appel API pour récupérer les événements en cours de validation
        try {
            const response = await axiosClient.get(`/dashboard/event-validation/editor/get-details/e/${id}`);
            
            if (response.data.noContent) {
                setError(response.data); // Afficher "Aucun résultat trouvé."
            } else {
                
                setEventDetails(response.data.event); // Données de l'événement
                setTickets(response.data.event.get_events); // Données de l'événement
            }
        } catch (error) {
            if (error.response && error.response.data) {
                // Récupérer les messages spécifiques de l'erreur backend
                setError(error.response.data);
            } else {
                setError({message: 'Une erreur inconnue est survenue. Veuillez réessayer plus tard.',});
            }
        } finally {
            setLoading(false); // Désactiver le spinner
        }
    };

    useEffect(() => {
        if (id) {
            fetchEventValidatorDetails();
        }
    }, [id]);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    if(!id) {
        return (
            <div className="w-full h-full flex justify-center items-center cweej">
                <div className="cydwr clbq0">
                    <div className="inline-flex items-center justify-center rounded-full c1qph c3x05 c7rlo ce36h cbcgo cdiog c3nk1 crzrx">
                        <svg className="cbm9w ctt6r cye3x" viewBox="0 0 20 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                            <path
                                className="text-gray-500 co1wq"
                                d="M10 10.562l9-5-8.514-4.73a1 1 0 00-.972 0L1 5.562l9 5z"
                                fill="currentColor"
                            />
                            <path
                                className="dark:text-gray-400 ckbo4"
                                d="M9 12.294l-9-5v10.412a1 1 0 00.514.874L9 23.294v-11z"
                                fill="currentColor"
                            />
                            <path
                                className="cmpw7 cdqku"
                                d="M11 12.294v11l8.486-4.714a1 1 0 00.514-.874V7.295l-9 4.999z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                    <h4 className="text-gray-800 dark:text-gray-100 font-bold text-lg c6f83">
                    Aucun événement trouvé, impossible d'accéder à cette page.
                    </h4>
                    <Link to={'/dashboard/events/validations'} className="btn bg-white border-gray-200 text-gray-800 cc0oq cghq3 cspbm c0zkc c2vpa">
                    Evénements en cours de validation
                    </Link>
                </div>
            </div>
        )
    }

    return (
        <div className='px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto'>
            <div className='grid grid-cols-12 gap-6'>
                <div className='col-span-full xl:col-span-12 bg-white dark:bg-gray-800 shadow-sm rounded-xl'>
                    
                    <header className="flex py-3 sm:px-6 px-3">
                        {/* Avatar */}
                        <img
                            className="rounded-full w-10 h-10 coqgc chfzq"
                            srcSet={`${imagePath}images/assist.png`}
                            alt="User Assistant"
                        />
                        {/* Meta */}
                        <div className="cbw8w">
                            <div className="mb-1 flex justify-between items-end">
                                <h4 className="text-md text-gray-800 dark:text-gray-100 font-semibold text-left">
                                    Informations importantes
                                </h4>
                                <button
                                    className="c3e4j cg12x cmpw7 cdqku c98dn"
                                    onClick={toggleDropdown} 
                                    >
                                    <span className="cn8jz">Menu</span>
                                    <svg className={`transition-transform transform cbm9w cue4z cmwfi ${isOpen ? 'rotate-180' : 'rotate-0'}`} viewBox="0 0 32 32">
                                        <path d="M16 20l-5.4-5.4 1.4-1.4 4 4 4-4 1.4 1.4z" />
                                    </svg>
                                </button>

                            </div>
                            {isOpen && (
                                <div className="text-sm">
                                    Votre événement est en attente de validation. Vous pouvez encore modifier les informations.
                                    
                                    Une fois publié, certaines modifications ne seront plus possibles. Vous devrez <Link className='text-blue-500' to={`/dashboard/account/administration-organizer/contact/events-supprort-organizers`}>contacter l’administrateur</Link> pour toute mise à jour.
                                    <br /><br />
                                    <p>
                                    La validation se fait en quelques minutes. Pensez à bien vérifier vos informations.
                                    
                                    Vous pouvez <Link className='text-blue-500' to={`/dashboard/events/validations/show/info-e/${eventDetails.id}`}>ajouter une attestation</Link> de tenue d’événement (facultatif) pour accélérer la validation.
                                    </p>
                                </div>
                            )}
                        </div>
                    </header>
                </div>
                <div className='col-span-full xl:col-span-12 bg-white dark:bg-gray-800 shadow-sm rounded-xl'>

                    <div className="py-3 sm:px-6 px-3 cvsuf">
                        {loading ? (
                            <LoadContentSpinner />
                        ) : eventDetails ? (

                            <FormDatasEdit datasEvents={eventDetails} datasPass={tickets} refresh={fetchEventValidatorDetails} />
                        ) : (
                            <div className="w-full h-full flex justify-center items-center cweej">
                                <div className="cydwr clbq0">
                                    <div className="inline-flex items-center justify-center rounded-full c1qph c3x05 c7rlo ce36h cbcgo cdiog c3nk1 crzrx">
                                        <svg className="cbm9w ctt6r cye3x" viewBox="0 0 20 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                                            <path
                                                className="text-gray-500 co1wq"
                                                d="M10 10.562l9-5-8.514-4.73a1 1 0 00-.972 0L1 5.562l9 5z"
                                                fill="currentColor"
                                            />
                                            <path
                                                className="dark:text-gray-400 ckbo4"
                                                d="M9 12.294l-9-5v10.412a1 1 0 00.514.874L9 23.294v-11z"
                                                fill="currentColor"
                                            />
                                            <path
                                                className="cmpw7 cdqku"
                                                d="M11 12.294v11l8.486-4.714a1 1 0 00.514-.874V7.295l-9 4.999z"
                                                fill="currentColor"
                                            />
                                        </svg>
                                    </div>
                                    <h4 className="text-gray-800 dark:text-gray-100 font-bold text-lg c6f83">
                                    OUPS
                                    </h4>
                                    <div className="mb-6 text-sm">
                                    {error.message}
                                    </div>
                                    {error.errorCode === 'EVENT_ACCESS_DENIED' && (
                                        <Link to={'/dashboard/events/validations'} className="btn bg-white border-gray-200 text-gray-800 cc0oq cghq3 cspbm c0zkc c2vpa">
                                        Evénements en cours de validation
                                        </Link>
                                    )}
                                    {error.errorCode === 'EVENT_NOT_PENDING' && (
                                        <Link to={'/dashboard/events/show-list'} className="btn bg-white border-gray-200 text-gray-800 cc0oq cghq3 cspbm c0zkc c2vpa">
                                        Retour aux événements
                                        </Link>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
